import { CalendarCellAriaLabel } from './calendar-cell-aria-label.pipe';

export const CALENDAR_CELL_ARIA_LABEL = [CalendarCellAriaLabel];

export * from './calendar-cell-aria-label.pipe';
